import React, { Component } from 'react';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import i18n from 'helpers/i18n';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import clsx from 'clsx';

const LIVE_ACTIVATION_DELAY = 15;

const styles = (theme) => {
  return {
    banner: {
      color: theme.palette.banner.color,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      marginTop: theme.spacing(4),
      position: 'relative',
      '&:before': {
        content: "' '",
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: theme.palette.banner.backgroundColor,
        backgroundImage: theme.palette.banner.backgroundImage,
        backgroundRepeat:'no-repeat',
        height:'355px',
        width:'100%',
        zIndex:-1,
      },
      '& .MuiTypography-h3':{
        fontSize:'200%',
        fontWeight:'bold',
        margin:theme.spacing(3),
        padding:0,
      },
      '& .MuiTypography-h5':{
        fontSize:'100%',
        fontWeight:'bold',
        margin:theme.spacing(2),
        marginBottom:theme.spacing(4),
        padding:0,
      },
      '& .MuiTypography-root':{
        color: theme.palette.banner.color,
      },
      '& .MuiTypography-body1': {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    bloc:{
      backgroundImage: 'url('+(require('assets/images/home_intro_bg.svg'))+')',
      backgroundRepeat:'no-repeat',
      height:'250px',
      maxWidth: '419px',
      margin:'20px',
    },
    image:{
      margin: "20px",
      verticalAlign:'middle',
      [theme.breakpoints.down('xs')]: {
        maxWidth:'80px',
        height:'auto',
      },
    },
    image_0:{
      marginTop: "68px",
    },
    image_1:{
      //marginTop: "58.5px",
      marginTop: "56px",
    },
    text:{
      display:'inline-block',
      width: '225px',
      color:'#222 !important',
      padding:'0 !important',
      margin:'0 !important',
      fontSize:'11pt',
      textAlign:'left',
      verticalAlign:'middle',
      [theme.breakpoints.down('xs')]: {
        width: '180px',
        fontSize:'90%',
      },
    },

  };
};
class HomeIntro extends Component {
  render() {
    const { $$intro, classes } = this.props;

    return (
        <Grid
          item
          xs={12}
          container
          spacing={0}
          alignItems="center"
          justify="center"
          className={classes.banner}
        >
          <If condition={i18n.has('homeBannerTitle')}>
            <Grid item xs={12}>
              <Typography variant={'h3'} align="center">
                {i18n.get('homeBannerTitle')}
              </Typography>
              <If condition={i18n.has('homeBannerSubTitle')}>
                <Typography variant={'h5'} align="center">
                  {i18n.get('homeBannerSubTitle')}
                </Typography>
              </If>
            </Grid>
          </If>
          {$$intro
            .map(($$i, idx) => {
              const mdSize = $$intro.size === 2 ? 6 : 4;
              const img=$$i.get('image');
              return (
                <Grid item xs={12} sm={12} md={mdSize} key={'int_' + idx} className={classes.bloc}>
                  <If condition={img!=undefined}>
                      <img src={require('assets/images/'+img)} className={clsx(classes.image, classes['image_'+idx])}/>
                  </If>
                  <Typography variant="body1" align="center" gutterBottom component="div" className={classes.text}>
                    <Paragrapher text={$$i.get('title')} prettyfy={true} element="div" />
                  </Typography>
                </Grid>
              );
            })
            .toArray()}
        </Grid>
    );
  }
}

export default withRouter(withStyles(styles)(HomeIntro));



// WEBPACK FOOTER //
// ./src/components/Home/HomeIntro.jsx